import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FilterMatchMode } from 'primeng/api';

@Component({
  selector: 'app-multiselect-filter',
  templateUrl: './multiselect-filter.component.html',
  styleUrls: ['./multiselect-filter.component.css']
})
export class MultiSelectFilterComponent implements OnInit {
  @Input() field: any;
  @Input() table: any;
  @Input() filters: any;
  filterFormGroup: FormGroup;
  @Output() applyFilter: EventEmitter<any> = new EventEmitter<any>();
  @Output() getSelectedIds: EventEmitter<any> = new EventEmitter<any>();
  @Input() values = [];
  @Input() optionLabel: any;
  @Input() optionValue: any;
  @Input() public selectedIds: Array<any> = []
  matchModeOptions = [
    { label: "In", value: "in" },
    { label: "Not In", value: "not-in" },
  ];
  public statusIds: Array<any> = [];
  selectedIdsOnChange;
  constructor(private _fb: FormBuilder) { }

  ngOnInit(): void {
    this.initialSetup();
  }
  onChange(UpdatedValue : []) :void
  {
    this.selectedIds = UpdatedValue;
  }
  initialSetup() {
    this.filterFormGroup = this._fb.group({
      matchModeControl: new FormControl('custom-equals'),
      //valueControl: new FormControl(null)
    })
  }

  apply(formGroup, fieldName) {
    let value = formGroup.value;
    if(this.selectedIdsOnChange == undefined)
    {
      for(var k=0;k<this.selectedIds.length;k++)
      {
        if(this.selectedIdsOnChange ==undefined)
        {
          this.selectedIdsOnChange =this.selectedIds[k];
        }
        else{
          this.selectedIdsOnChange =this.selectedIdsOnChange +','+this.selectedIds[k];
        }
      }
    }
    this.table.filters[fieldName][0].value = this.selectedIdsOnChange;
    this.table.filters[fieldName][0].matchMode = value.matchModeControl;
    this.table.filters[fieldName][0].operator = 'and';
    this.filters = this.table.filters;
    this.applyFilter.emit();
  }

  clear(fieldName) {
    for (let i = 0; i < this.table.filters[fieldName].length; i++) {
      this.table.filters[fieldName][i].value = null;
      this.table.filters[fieldName][i].matchMode = "custom-equals";
      this.table.filters[fieldName][i].operator = null;
    }
    this.filters = this.table.filters;
    this.selectedIds=[];
    this.applyFilter.emit();
  }
  getSelectedIdsOnChange(event)
  {
    this.getSelectedIds.emit(event);
    this.selectedIdsOnChange = "";
        if(event.value.length == 1)
        {
          this.selectedIdsOnChange = event.value[0];
        }
        else if(event.value.length > 1)
        {
         // this.selectedIds = "";
          for (var k = 0; k < event.value.length; k++) {
            if(k==0)
            {
              this.selectedIdsOnChange =event.value[k];
            }
            else{
              this.selectedIdsOnChange = this.selectedIdsOnChange + ',' + event.value[k];
            }
           
          }
        }
  }
  filterOpen(form: FormGroup, fieldName, control1) {
    if (this.table.filters[fieldName] != undefined) {
      for (let i = 0; i < this.table.filters[fieldName].length; i++) {
        form.controls[control1].setValue(this.table.filters[fieldName][i].matchMode);
        if(this.table.filters[fieldName][i].value != null && this.table.filters[fieldName][i].value != undefined){
         // form.controls[control2].setValue(this.table.filters[fieldName][i].value);
        // var selectedList =[];
        // if(String(this.selectedIds).includes(','))
        // {
        //   selectedList =String(this.selectedIds).split(',');
        //   console.log('sl',selectedList);
        //   console.log('sl',selectedList.length);
        //   console.log(this.values);
        //   for(let j=0;j<this.values.length;j++)
        //   {
        //     for(let k=0;k<selectedList.length;k++)
        //     {
        //       if(this.values[j].lookupOrder==selectedList[k])
        //       {
        //         console.log('in');
        //         this.statusIds.push(this.values[j]);
        //       }
        //     }
        //     console.log('st',this.statusIds);
        //   }
        // }
        // else{
        //   for(let j=0;j<this.values.length;j++)
        //   {
        //     if(this.values[j].lookupOrder==this.selectedIds)
        //       {
        //        // this.statusIds.push(this.values[j]);
        //       }
        //   }
        // }
        }else{
          //form.controls[control2].setValue(this.values[0][this.optionValue]);
        }
      }
    }
  }
}

